import {Routes} from '@angular/router';
import {qrOnlyGuard} from '@core/guards/qr-only-guard';
import {mobileOnlyGuard} from '@core/guards/mobile-only-guard';
import {Splash} from './layout/views/splash/splash';
import {MobileOnly} from './layout/views/mobile-only/mobile-only';
import {Main} from './layout/views/main/main';
import {Categories} from './layout/views/categories/categories';
import {Menu} from './layout/views/menu/menu';
import {ProductDetail} from './layout/views/product-detail/product-detail';
import {CartView} from './layout/views/cart/cart';
import {Tracking} from './layout/views/tracking/tracking';
import {Success} from './layout/views/success/success';

export const routes: Routes = [
  {
    path: 'splash/:table/qr',
    canActivate: [mobileOnlyGuard],
    component: Splash
  },
  {
    path: 'mobile-only',
    component: MobileOnly
  },
  {
    path: 'splash',
    canActivate: [mobileOnlyGuard],
    component: Splash
  },
  {
    path: 'standard',
    canActivate: [qrOnlyGuard],
    component: Main,
    children: [
      {
        path: 'categories',
        component: Categories,
        data: {title: 'Menú', headerVisible: true, backButton: false}
      },
      {
        path: 'menu/:category',
        component: Menu,
        data: {headerVisible: true, backButton: true}
      },
      {
        path: 'product/:id',
        component: ProductDetail,
        data: {
          title: 'Más Información',
          headerVisible: true,
          backButton: true
        }
      },
      {
        path: 'cart',
        component: CartView,
        data: {title: 'Mi Orden', headerVisible: true, backButton: true}
      },
      {
        path: 'tracking',
        component: Tracking,
        data: {title: 'Seguimiento', headerVisible: true, backButton: true}
      },
      {
        path: 'success',
        component: Success,
        data: {title: 'Pedido Finalizado', headerVisible: true, backButton: false}
      },
      {
        path: '',
        redirectTo: 'categories',
        pathMatch: 'full'
      }
    ]
  },
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'splash'
  },
  {
    path: '**',
    redirectTo: 'splash'
  }
];
